<template>
	<b-modal
		ref="depurations-detail-modal"
		:title="`Motivos de depuración / ${getTitle}`"
		size="xlg"
		centered
		hide-footer
		scrollable
		@hidden="handleHidden"
	>
		<b-overlay :show="isLoading">
			<h5 class="text-uppercase">
				Total de depurados:
				<span class="text-primary underline-hover" @click="handleChartClick(null)">
					{{ info.depu_total }}
				</span>
			</h5>
			<VueApexCharts type="pie" height="400" :options="chartOpts" :series="chartData" />
		</b-overlay>
		<PadrillosMadrillasByDepurationReasonModal
			v-if="showPosturesByDepurationReason"
			:start_date="season == null ? null : season.start"
			:end_date="season == null ? null : season.end"
			:selectedReason="selectedReason"
			:lote_id="info.id"
			@closing="showPosturesByDepurationReason = false"
		/>
	</b-modal>
</template>

<script>
import lotesService from "@/services/lotes.service"
import moment from "moment"
import PadrillosMadrillasByDepurationReasonModal from "@/views/amg/encaste/lotes/modals/depuration_reasons/PadrillosMadrillasByDepurationReasonModal.vue"
import VueApexCharts from "vue-apexcharts"

export default {
	components: { VueApexCharts, PadrillosMadrillasByDepurationReasonModal },
	props: {
		info: Object,
		isGeneral: { type: Boolean, required: false, default: false },
		season: Object,
	},
	data: () => ({
		isLoading: false,
		chartData: [1],
		chartOpts: {
			labels: ["base"],
		},
		showPosturesByDepurationReason: false,
		selectedReason: null,
		reasons: [],
	}),
	async mounted() {
		await this.getReasonsReport()
		this.$refs["depurations-detail-modal"].toggle()
	},
	computed: {
		getTitle() {
			if (!this.isGeneral) return `Lote ${this.info.code || "---"}`

			const tempYear = moment(this.season.start).year()
			return `Lotes de temporada ${tempYear}`
		},
	},
	methods: {
		handleHidden() {
			this.isLoading = false
			this.$emit("close")
		},
		handleChartClick(index) {
			this.selectedReason =
				index != null
					? this.reasons[index]
					: {
							id: null,
							reason: "Todos los motivos",
							is_total: 1,
							qty: this.info.depu_total,
					  }
			this.showPosturesByDepurationReason = true
		},
		async getReasonsReport() {
			try {
				const { data } = await lotesService.getReasonsForDepurationReport({
					lote_id: this.info.id,
					start_date: this.info.id ? null : this.season.start,
					end_date: this.info.id ? null : this.season.end,
				})
				const qtys = []
				const labels = []
				data.sort((a, b) => Number(b.qty) - Number(a.qty))
				data.forEach((data) => {
					qtys.push(Number(data.qty))
					labels.push(String(data.reason ?? "Sin motivo").toUpperCase())
				})
				this.reasons = data
				this.chartData = qtys
				this.chartOpts = {
					chart: {
						type: "pie",
						events: {
							dataPointSelection: (event, chartContext, config) => {
								this.handleChartClick(config.dataPointIndex)
							},
						},
					},
					labels,
					dataLabels: {
						formatter: function (value, { seriesIndex }) {
							return `${Number(value).toFixed(1)}%=${qtys[seriesIndex]}`
						},
						style: { colors: ["#fff"] },
					},
					legend: {
						formatter: function (seriesName, opts) {
							return [seriesName, " : ", opts.w.globals.series[opts.seriesIndex]]
						},
					},
				}
			} catch (error) {
				console.log("errorr: ", error)
			} finally {
				this.isLoading = false
			}
		},
	},
}
</script>
<style lang="scss" scoped>
.underline-hover {
	text-decoration: underline;
	transition: all 0.1s ease;
}
.underline-hover:hover {
	font-weight: bold;
	cursor: pointer;
	font-size: 1.2rem;
}
</style>
